import { UtpCardStructure } from 'common/components';
import { KITCHEN_CDN_PATH } from '../../../kitchen-constants';
import { DeliniaId, Factories, Manager, Quality, Support } from './components';

export const KITCHEN_UTP_CARD_LIST: UtpCardStructure<Record<string, never>>[] = [
  {
    elementName: 'Собственный бренд Delinia ID',
    header: {
      title: 'Собственный бренд Delinia\u00A0ID',
    },
    description: {
      text: '',
    },
    image: {
      alt: 'Кухня Delinia ID',
      src: `${KITCHEN_CDN_PATH}/utp/delinia-id.png/delinia-id2.png`,
    },
    modal: { content: DeliniaId },
  },
  {
    elementName: 'Проверяем качество вручную',
    header: {
      title: 'Проверяем качество вручную',
    },
    description: {
      text: '',
    },
    image: {
      alt: 'Проверка качества',
      src: `${KITCHEN_CDN_PATH}/utp/quality.png/quality2.png`,
    },
    modal: { content: Quality },
  },
  {
    elementName: 'Более 48 мебельных фабрик',
    header: {
      title: 'Более 48\u00A0мебельных фабрик',
    },
    description: {
      text: '',
    },
    image: {
      alt: 'Мебельные фабрики',
      src: `${KITCHEN_CDN_PATH}/utp/factories.png/factories2.png`,
    },
    modal: { content: Factories },
  },
  {
    elementName: 'Персональный менеджер',
    header: {
      title: 'Персональный менеджер',
    },
    description: {
      text: '',
    },
    image: {
      alt: 'Персональный менеджер',
      src: `${KITCHEN_CDN_PATH}/utp/manager.png/manager2.png`,
    },
    modal: { content: Manager },
  },
  {
    elementName: 'Сервисная поддержка',
    header: {
      title: 'Сервисная поддержка',
    },
    description: {
      text: '',
    },
    image: {
      alt: 'Сервисная поддержка',
      src: `${KITCHEN_CDN_PATH}/utp/support.png/support2.png`,
    },
    modal: { content: Support },
  },
];
